import { render } from "./quant.vue?vue&type=template&id=d5052de2&scoped=true&ts=true"
import script from "./quant.vue?vue&type=script&lang=ts"
export * from "./quant.vue?vue&type=script&lang=ts"

import "./quant.vue?vue&type=style&index=0&id=d5052de2&scoped=true&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5052de2"]])

export default __exports__